/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Description } from "@nordcloud/gnui";
import { isValidDecimalSchema, isValidNonNegativeValSchema } from "~/tools";

export function ValidationMessageTime() {
  return <Description>Time is not valid.</Description>;
}

export const checkTime = (start: string, end: string) => {
  if (!start || !end) {
    return null;
  }

  return start?.length === 0 || end?.length === 0 ? null : { start, end };
};

export const isValidTime = (time: string) => {
  if (time === "") {
    return true;
  }

  return (
    isValidDecimalSchema.safeParse(time).success &&
    isValidNonNegativeValSchema.safeParse(parseFloat(time)).success
  );
};
